import { EnumBase } from 'hay-core-react';
class ContratoSituacaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.contrato.situacao.pendente',
                'main.contrato.situacao.ativo',
                'main.contrato.situacao.suspenso',
                'main.contrato.situacao.cancelado',
            ],
            'main.contrato.situacao.pendente'
        );
    }
}

const instance = new ContratoSituacaoEnum();
export default instance;
